/* Wurzel & Flügel — theme.js
   Vanilla JS only. Handles: mobile nav toggle, scroll-reveal, FAQ accordion,
   product gallery thumbnails (images + videos), quantity stepper, and cart drawer open/refresh.
   No external dependencies — keeps the theme lightweight and Online Store 2.0 safe. */
(function () {
  "use strict";

  /* ---------- Mobile nav ---------- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-wuf-mobile-toggle]");
    if (toggle) {
      var nav = document.querySelector("[data-wuf-mobile-nav]");
      if (nav) nav.classList.toggle("is-open");
    }
  });

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll("[data-wuf-reveal]");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------- FAQ accordion ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".wuf-faq__question");
    if (!btn) return;
    var item = btn.closest(".wuf-faq__item");
    var wasOpen = item.classList.contains("is-open");
    item.parentElement.querySelectorAll(".wuf-faq__item").forEach(function (el) {
      el.classList.remove("is-open");
      var q = el.querySelector(".wuf-faq__question");
      if (q) q.setAttribute("aria-expanded", "false");
    });
    if (!wasOpen) {
      item.classList.add("is-open");
      btn.setAttribute("aria-expanded", "true");
    }
  });

  /* ---------- Product gallery thumbnails (images + videos) ---------- */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest("[data-wuf-thumb]");
    if (!thumb) return;
    var gallery = thumb.closest("[data-wuf-gallery]");
    if (!gallery) return;

    var mainImg = gallery.querySelector("[data-wuf-gallery-main]");
    var mainVideo = gallery.querySelector("[data-wuf-gallery-video]");
    var mediaType = thumb.getAttribute("data-media-type") || "image";

    if (mediaType === "video") {
      var videoSrc = thumb.getAttribute("data-video-src");
      var poster = thumb.getAttribute("data-poster");
      if (mainVideo && videoSrc) {
        mainVideo.pause();
        mainVideo.setAttribute("src", videoSrc);
        if (poster) mainVideo.setAttribute("poster", poster);
        mainVideo.load();
        mainVideo.classList.remove("wuf-hidden");
      }
      if (mainImg) mainImg.classList.add("wuf-hidden");
    } else {
      var fullSrc = thumb.getAttribute("data-full-src");
      if (mainVideo) {
        mainVideo.pause();
        mainVideo.removeAttribute("src");
        mainVideo.classList.add("wuf-hidden");
      }
      if (mainImg && fullSrc) {
        mainImg.setAttribute("src", fullSrc);
        mainImg.classList.remove("wuf-hidden");
      }
    }

    gallery.querySelectorAll("[data-wuf-thumb]").forEach(function (t) {
      t.classList.remove("is-active");
    });
    thumb.classList.add("is-active");
  });

  /* ---------- Quantity stepper (product form) ---------- */
  document.addEventListener("click", function (e) {
    var stepBtn = e.target.closest("[data-wuf-qty-step]");
    if (!stepBtn) return;
    var wrapper = stepBtn.closest(".wuf-qty-input");
    var input = wrapper && wrapper.querySelector("input[type='number']");
    if (!input) return;
    var step = parseInt(stepBtn.getAttribute("data-wuf-qty-step"), 10);
    var current = parseInt(input.value, 10) || 1;
    var next = Math.max(1, current + step);
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: null,
    init: function () {
      this.drawer = document.querySelector("[data-wuf-cart-drawer]");
      var self = this;

      document.addEventListener("click", function (e) {
        if (e.target.closest("[data-wuf-cart-open]")) {
          e.preventDefault();
          self.open();
        }
        if (e.target.closest("[data-wuf-cart-close]")) {
          e.preventDefault();
          self.close();
        }
        var removeBtn = e.target.closest("[data-wuf-cart-remove]");
        if (removeBtn) {
          e.preventDefault();
          self.removeLine(removeBtn.getAttribute("data-line"));
        }
      });

      document.addEventListener("submit", function (e) {
        var form = e.target;
        if (form.matches('form[action*="/cart/add"]')) {
          e.preventDefault();
          self.addFromForm(form);
        }
      });
    },
    open: function () {
      if (this.drawer) this.drawer.classList.add("is-open");
      document.documentElement.style.overflow = "hidden";
    },
    close: function () {
      if (this.drawer) this.drawer.classList.remove("is-open");
      document.documentElement.style.overflow = "";
    },
    addFromForm: function (form) {
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.originalText = submitBtn.dataset.originalText || submitBtn.textContent;
        submitBtn.textContent = "Wird hinzugefügt …";
      }
      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + "cart/add.js"
        : "/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return Cart.refresh();
        })
        .then(function () {
          Cart.open();
        })
        .catch(function (err) {
          console.error("Wurzel & Flügel: cart/add failed", err);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.originalText;
          }
        });
    },
    removeLine: function (key) {
      if (!key) return;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 }),
      })
        .then(function () { return Cart.refresh(); })
        .catch(function (err) { console.error("Wurzel & Flügel: cart/change failed", err); });
    },
    refresh: function () {
      return fetch("/?sections=cart-drawer")
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var key = Object.keys(data)[0];
          if (!key) return;
          var temp = document.createElement("div");
          temp.innerHTML = data[key];
          var newDrawer = temp.querySelector("[data-wuf-cart-drawer]");
          if (newDrawer && Cart.drawer) {
            var wasOpen = Cart.drawer.classList.contains("is-open");
            Cart.drawer.replaceWith(newDrawer);
            Cart.drawer = newDrawer;
            if (wasOpen) Cart.drawer.classList.add("is-open");
          }
        });
    },
  };

  document.addEventListener("DOMContentLoaded", function () {
    Cart.init();
  });
})();
